export default function PageContent({ children }: { children: React.ReactNode }) {
    return (
        <div className="fluid-container my-8 content-prose">
            {children}
        </div>
    );
}